import { Featured, ContentfulFeatured } from './../types'
import {
  getFeatured,
  getFeaturedByArticle,
  getFeaturedList,
  filterPublished,
} from './api/contentful'
import { convertArticle } from './article'
import { withProtocol } from './url'
import { printError } from './log'

export const fetchFeatured = async (featuredSlug: string) => {
  let featured: Featured | null = null
  try {
    const data = await getFeatured(featuredSlug)
    if (data) {
      featured = convertFeatured(data)
    }
  } catch (e) {
    printError(e)
  }
  return featured
}

export const fetchFeaturedList = async () => {
  let featuredList: Featured[] = []
  try {
    const items = await getFeaturedList()
    featuredList = items.map((item) => convertFeatured(item))
  } catch (e) {
    printError(e)
  }
  return featuredList
}

export const fetchFeaturedByArticle = async (articleId: string) => {
  let featured: Featured | null = null
  try {
    const data = await getFeaturedByArticle(articleId)
    if (data) {
      featured = convertFeatured(data)
    }
  } catch (e) {
    printError(e)
  }
  return featured
}

export const convertFeatured = (featured: ContentfulFeatured): Featured => {
  const headerImage = {
    url: withProtocol(featured.headerImage.fields.file.url),
    title: featured.headerImage.fields.title,
  }
  const ogpImage = {
    url: withProtocol(featured.ogpImage.fields.file.url),
    title: featured.ogpImage.fields.title,
  }
  const articles = filterPublished(featured.articles).map((res) =>
    convertArticle({ ...res.fields, id: res.sys.id })
  )
  return {
    ...featured,
    articles,
    headerImage,
    ogpImage,
  }
}

export const trimTextForNewsPicks = (text: string) => {
  return text.replace('スタートアップ最前線', '')
}
